import { Paper, styled } from '@mui/material';
import { theme, breakpoints } from 'assets/themes/zizzi';
import Carousel from 'components/Carousel';
import Markdown from 'components/Markdown';

const { galaxyFold } = breakpoints;

export const StyledCarousel = styled(Carousel)`
  padding: 1rem;

  ${theme.breakpoints.up('md')} {
    margin: 0 -1rem;
  }
`;

export const StyledPaper = styled(Paper)`
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  flex-grow: 1;
  min-width: 300px;

  @media (max-width: 349px) {
    min-width: 250px;
  }

  ${theme.breakpoints.up('md')} {
    margin-left: 0;
    min-width: 550px;
  }
`;

export const GridBox = styled('div')`
  display: grid;
  grid-template-rows: 40px 50px 50px 60px;
  grid-template-areas:
    'header header header header header header'
    'image image content content content content'
    'image image content content content content'
    'footer footer footer footer footer footer';
  gap: 10px;

  ${theme.breakpoints.up('md')} {
    grid-template-rows: 50px 80px 80px;
    grid-template-areas:
      'header header header header header header'
      'image image content content content content'
      'image image footer footer footer footer';
    padding: 10px;
  }

  h3 {
    grid-area: header;

    @media (max-width: ${galaxyFold}) {
      font-size: 0.9rem;
    }
  }

  svg {
    grid-area: image;
    justify-self: start;
    width: 100%;
    height: 100%;
    ${theme.breakpoints.up('md')} {
      width: 90%;
      height: 90%;
    }
  }

  p,
  div {
    grid-area: content;
    align-self: center;
  }

  a {
    grid-area: footer;
    align-self: end;

    @media (max-width: ${galaxyFold}) {
      line-height: 1;
    }
  }
`;

export const StyledMarkdown = styled(Markdown)`
  ${theme.breakpoints.down('md')} {
    line-height: 19px;
  }

  img[src$='#MoreIcon'] {
    margin: 0 -5px -7px;
  }

  img[src$='#IosShareIcon'] {
    margin: 0 0 -4px;
  }
`;
